import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
} from "@mui/material";

interface Question {
  id: string;
  question: string;
  question_type: string;
  would_interviewer_know_answer?: boolean;
  is_question_multi_part_explanation?: boolean;
  would_answer_overlap_another_question?: boolean;
}

interface AddQuestionDialogProps {
  open: boolean;
  onClose: () => void;
  onAdd: (question: Partial<Question>) => void;
  newQuestion: Partial<Question>;
  onQuestionChange: (question: Partial<Question>) => void;
}

const AddQuestionDialog: React.FC<AddQuestionDialogProps> = ({
  open,
  onClose,
  onAdd,
  newQuestion,
  onQuestionChange,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Add New Question</DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 2 }}>
          <TextField
            fullWidth
            label="Question Text"
            multiline
            rows={3}
            value={newQuestion.question || ""}
            onChange={(e) =>
              onQuestionChange({ ...newQuestion, question: e.target.value })
            }
            sx={{ mb: 2 }}
          />
          <FormControl fullWidth>
            <InputLabel>Question Type</InputLabel>
            <Select
              value={newQuestion.question_type || "general"}
              onChange={(e) =>
                onQuestionChange({
                  ...newQuestion,
                  question_type: e.target.value,
                })
              }
              label="Question Type"
            >
              <MenuItem value="general">General</MenuItem>
              <MenuItem value="behavioral">Behavioral</MenuItem>
              <MenuItem value="informational">Informational</MenuItem>
              <MenuItem value="scenario">Scenario</MenuItem>
              <MenuItem value="background">Background</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={() => onAdd(newQuestion)}
          variant="contained"
          disabled={!newQuestion.question}
        >
          Add Question
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddQuestionDialog;
